import { getItemFromCollection, getDirectusField } from "directus/src/operations";

export async function fetchMilestone({ milestoneId }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "status",
        "start_date",
        "end_date",
        "job.id",
        "job.name",
        "job.type",
        "job.project.id",
        "job.project.name",
        "job.project.project_id",
      ],
    };

    const data = await getItemFromCollection("milestones", milestoneId, query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchMilestoneStatuses() {
  try {
    const response = await getDirectusField("milestones", "status");
    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
